import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import ReactVortoxSpinner from "../common-components/ReactVortoxSpinner";
import PaymentLinkTable from "../payment-link-system/PaymentLinkTable";
import { convertThenFormat, formatDateTime } from "../common-data/Converts";
// import ExpenseRequestListsMobile from "./ExpenseRequestListsMobile";
import { formatWTFString } from "../common-data/Conversions";
import ExpenseStats from "./expense-management/ExpenseStats";
import VendorImageUploadModal from "./VendorImageUploadModal";
import ExpenseRequestListsMobileV2 from "./ExpenseRequestListsMobileV2";
import {
  CompletedIcon,
  ClockIcon,
  PendingIcon,
  CrossIcon,
  EyeIcon,
  CloudUploadIcon,
  WarningIcon,
} from "../../images/icons/icons";

export const getStatusLabel = (status) => {
  let statusLabel = "";
  switch (status) {
    case "approved_paid":
      statusLabel = "Approved/Paid";
      break;
    case "approved_notpaid":
      statusLabel = "Approved/Not Paid";
      break;
    case "pending":
      statusLabel = "Approval Pending";
      break;
    case "rejected_by_acc":
      statusLabel = "Rejected By Accountant";
      break;
    default:
      statusLabel = status;
      break;
  }
  return statusLabel;
};

export const getStatusIcon = (status) => {
  const planStatus = status?.replace(/ /g, "_")?.toLowerCase();

  switch (planStatus) {
    case "approved_paid":
      return <CompletedIcon />;
    case "approved_notpaid":
      return <ClockIcon />;
    case "pending":
      return <PendingIcon />;
    default:
      return <CrossIcon />;
  }
};

const ExpenseRequestLists = ({
  userInfoData,
  isPage,
  setIsPage,
  pageLimit,
  setPageLimit,
  setModValues,
  isExpenseManager,
  callFunction,
  onCardClick,
  selectedStatus,
  allExpenseStats,
  allExpenseStatsLoading,
}) => {
  const { expenseRequestsLoading, expenseRequests } = useSelector(
    (state) => state.hygiene
  );

  const expenseManagerRole =
    (isExpenseManager && isExpenseManager?.role_type) || null;

  const iniPTDatas = {
    pagination: [],
    allData: [],
  };
  const [allDatas, setAllDatas] = useState(iniPTDatas);

  // Vendor image upload modal state
  const [vendorImageModal, setVendorImageModal] = useState({
    isOpen: false,
    expenseId: null,
    expenseRow: null,
  });

  const handleVendorImageUpload = (expenseId, row) => {
    setVendorImageModal({
      isOpen: true,
      expenseId,
      expenseRow: row,
    });
  };

  const closeVendorImageModal = () => {
    setVendorImageModal({
      isOpen: false,
      expenseId: null,
      expenseRow: null,
    });
  };

  const handleVendorUploadSuccess = () => {
    closeVendorImageModal();
    if (callFunction) {
      callFunction();
    }
  };

  useEffect(() => {
    if (expenseRequests?.status && expenseRequests?.data?.length > 0) {
      setAllDatas((prevs) => ({
        ...prevs,
        allData: expenseRequests.data,
        pagination:
          expenseRequests?.pagination?.length > 0
            ? expenseRequests.pagination
            : [],
      }));
    } else {
      setAllDatas(iniPTDatas);
    }
  }, [expenseRequests]);

  const tbColumns = [
    {
      dataField: "request_summary",
      text: "Request Summary",
      formatter: (_, row) => {
        const planStatus = row?.status?.replace(/ /g, "_")?.toLowerCase();

        return (
          <div className="tb-data minWidth100" style={{ textAlign: "left" }}>
            {/* Status Section */}
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "6px",
                marginBottom: "8px",
              }}
            >
              {getStatusIcon(row?.status)}
              <strong style={{ fontSize: "13px" }}>
                {getStatusLabel(row?.status || "-")}
              </strong>
            </div>

            {/* Requested By Section */}
            <div style={{ marginBottom: "8px" }}>
              <div
                style={{
                  fontWeight: "bold",
                  fontSize: "14px",
                  marginBottom: "2px",
                }}
              >
                {row?.requested_by_name || "NA"}
              </div>
              <div style={{ fontSize: "12px", color: "#666" }}>
                {row?.requested_by_account_type && (
                  <span style={{ marginRight: "8px" }}>
                    {row.requested_by_account_type}
                  </span>
                )}
                {row?.requested_by_mobile && (
                  <span>{row.requested_by_mobile}</span>
                )}
              </div>
            </div>

            {/* Amount Section */}
            <div>
              <span
                style={{
                  fontSize: "16px",
                  fontWeight: "bold",
                  color: "#0066cc",
                  backgroundColor: "#e6f3ff",
                  padding: "4px 8px",
                  borderRadius: "4px",
                }}
              >
                ₹{convertThenFormat(row?.requested_amount || 0)}
              </span>
            </div>
          </div>
        );
      },
    },

    {
      dataField: "approval_manager",
      text: "Action Pending From",
      formatter: (_, row) => {
        return (
          <span className="tb-data minWidth70" style={{ fontSize: "14px" }}>
            {row?.pending_at || "NA"}
            <br />
            <small
              className="underline"
              style={{ textTransform: "capitalize" }}
            >
              {row?.pending_at_mobile && (
                <>
                  {row.pending_at_mobile}
                  <br />
                </>
              )}
              {row?.pending_at_account_type && (
                <>
                  {row.pending_at_account_type.replace(/_/g, " ")}
                  <br />
                </>
              )}
            </small>
          </span>
        );
      },
    },
    {
      dataField: "approval_manager",
      text: "Approval Manager",
      formatter: (_, row) => {
        return (
          <span className="tb-data minWidth70" style={{ fontSize: "14px" }}>
            {row?.approval_manager_name || "NA"}
            <br />
            <span className="underline">
              {row?.approval_manager_mobile || "NA"}
            </span>
            <br />
            <span className="underline">
              {row?.approval_manager_account_type?.replace(/_/g, " ") || "NA"}
            </span>
          </span>
        );
      },
    },
    {
      dataField: "payee_type",
      text: "Payee Type",
      formatter: (_, row) => {
        return (
          <span className="tb-data" style={{ fontSize: "14px" }}>
            {row?.payee_type || "NA"}
          </span>
        );
      },
    },
    {
      dataField: "self_payment_status",
      text: "Self Payment Status",
      formatter: (_, row) => {
        return (
          <div
            className="tb-data"
            style={{ textAlign: "center", minWidth: "150px" }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: "6px",
                flexDirection: "column",
              }}
            >
              {getStatusIcon(row?.status)}
              <strong style={{ fontSize: "13px" }}>
                {getStatusLabel(row?.status || "-")}
              </strong>
            </div>
          </div>
        );
      },
    },
    {
      dataField: "vendor_paid_img",
      text: "Frontdesk Vendor Payment Status",
      formatter: (_, row) => {
        const planStatus = row?.status?.replace(/ /g, "_")?.toLowerCase();
        const isReceptionist =
          userInfoData?.account_type === "receptionist" ||
          userInfoData?.account_type === "trainer";
        const isPaidStatus = planStatus === "approved_paid";

        return (
          <div
            className="actionButtonContainer"
            style={{
              flexDirection: "column",
              justifyContent: "center",
              gap: "8px",
              minWidth: "140px",
            }}
          >
            {row?.vendor_paid_img ? (
              // Payment completed with image - show success state
              <div style={{ textAlign: "center" }}>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: "6px",
                    marginBottom: "4px",
                    color: "#28a745",
                    fontWeight: "600",
                    fontSize: "12px",
                  }}
                >
                  <CompletedIcon />
                  Payment Verified
                </div>
                <img
                  src={row.vendor_paid_img}
                  alt="Payment Proof"
                  style={{
                    width: "60px",
                    height: "60px",
                    objectFit: "cover",
                    borderRadius: "8px",
                    cursor: "pointer",
                    border: "2px solid #28a745",
                  }}
                  onClick={() => {
                    const printWindow = window.open("", "_blank");
                    const printContent = `
                      <html>
                        <head>
                          <title>Payment Proof</title>
                          <style>
                            body { margin: 0; padding: 20px; display: flex; justify-content: center; align-items: center; min-height: 100vh; background: #f8f9fa; }
                            img { max-width: 100%; height: auto; border-radius: 8px; box-shadow: 0 4px 12px rgba(0,0,0,0.15); }
                          </style>
                        </head>
                        <body>
                          <img src="${row.vendor_paid_img}" alt="Payment Proof" />
                        </body>
                      </html>
                    `;
                    printWindow.document.write(printContent);
                    printWindow.document.close();
                  }}
                />
                <div
                  style={{
                    fontSize: "10px",
                    color: "#6c757d",
                    marginTop: "2px",
                  }}
                >
                  Click to view
                </div>
              </div>
            ) : isPaidStatus && isReceptionist ? (
              // Payment approved but image not uploaded - show upload action
              <div style={{ textAlign: "center" }}>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: "6px",
                    marginBottom: "8px",
                    color: "#ffc107",
                    fontWeight: "600",
                    fontSize: "12px",
                  }}
                >
                  <WarningIcon />
                  Proof Required
                </div>
                <button
                  type="button"
                  className="btn btn-warning"
                  onClick={() => handleVendorImageUpload(row?.uid, row)}
                  style={{
                    padding: "8px 16px",
                    fontSize: "12px",
                    fontWeight: "600",
                    borderRadius: "6px",
                    border: "none",
                    cursor: "pointer",
                    backgroundColor: "#ffc107",
                    color: "#000",
                    display: "flex",
                    alignItems: "center",
                    gap: "6px",
                  }}
                >
                  <CloudUploadIcon />
                  Add Vendor Receipt
                </button>
                <div
                  style={{
                    fontSize: "10px",
                    color: "#856404",
                    marginTop: "4px",
                  }}
                >
                  Payment made - attach receipt
                </div>
              </div>
            ) : isPaidStatus && !isReceptionist ? (
              // Payment approved but user can't upload - show waiting state
              <div style={{ textAlign: "center" }}>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: "6px",
                    marginBottom: "8px",
                    color: "#17a2b8",
                    fontWeight: "600",
                    fontSize: "12px",
                  }}
                >
                  <PendingIcon />
                  Awaiting Receipt
                </div>
                <div
                  style={{
                    padding: "12px",
                    backgroundColor: "#e7f3ff",
                    borderRadius: "6px",
                    border: "1px solid #bee5eb",
                  }}
                >
                  <div
                    style={{
                      fontSize: "11px",
                      color: "#0c5460",
                      textAlign: "center",
                    }}
                  >
                    Payment completed
                    <br />
                    <strong>Receipt will be added by frontdesk</strong>
                  </div>
                </div>
              </div>
            ) : !isPaidStatus ? (
              // Payment not yet approved - show pending state
              <div style={{ textAlign: "center" }}>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: "6px",
                    marginBottom: "8px",
                    color: "#6c757d",
                    fontWeight: "600",
                    fontSize: "12px",
                  }}
                >
                  <ClockIcon />
                  Processing
                </div>
                <div
                  style={{
                    padding: "12px",
                    backgroundColor: "#f8f9fa",
                    borderRadius: "6px",
                    border: "1px solid #dee2e6",
                  }}
                >
                  <div
                    style={{
                      fontSize: "11px",
                      color: "#6c757d",
                      textAlign: "center",
                    }}
                  >
                    {planStatus === "pending"
                      ? "Under review"
                      : planStatus === "approved_notpaid"
                      ? "Approved - processing payment"
                      : "Requires approval"}
                  </div>
                </div>
              </div>
            ) : (
              // Fallback case
              <div style={{ textAlign: "center" }}>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    padding: "12px",
                    color: "#6c757d",
                  }}
                >
                  <CrossIcon />
                </div>
                <div style={{ fontSize: "10px", color: "#6c757d" }}>
                  No Action Required
                </div>
              </div>
            )}
          </div>
        );
      },
    },
    {
      dataField: "details",
      text: "View Details",
      formatter: (_, row) => {
        return (
          <div
            className="actionButtonContainer"
            style={{
              flexDirection: "column",
              justifyContent: "center",
              gap: "0",
            }}
          >
            <button
              className="actionBtn icon"
              onClick={() => {
                setModValues((prevs) => ({
                  ...prevs,
                  isModOpen: true,
                  cardName: "view_details",
                  rowData: row,
                }));
              }}
            >
              <EyeIcon />
            </button>
          </div>
        );
      },
    },
    {
      dataField: "date_added",
      text: "Date Added",
      formatter: (_, row) => {
        return (
          <span className="tb-data minWidth100" style={{ fontSize: "14px" }}>
            {row?.date_added ? formatDateTime(row.date_added) : "-"}
          </span>
        );
      },
    },
    {
      dataField: "expense_type",
      text: "Expense Type",
      formatter: (_, row) => {
        return (
          <span className="tb-data minWidth100">
            <b
              className="underline"
              style={{
                backgroundColor: "#e6f3ff",
                padding: "4px 8px",
                borderRadius: "4px",
                color: "#0066cc",
              }}
            >
              {formatWTFString(row?.expense_type || "")}
            </b>
            {row?.gym_name ? (
              <span style={{ fontSize: "14px" }}>
                <br />
                {row.gym_name}
              </span>
            ) : null}
          </span>
        );
      },
    },

    {
      dataField: "payment_method",
      text: "Payment Method",
      formatter: (_, row) => {
        return (
          <span className="tb-data minWidth150">
            <b className="underline">{row?.payment_method || "NA"}</b>

            {row?.payment_method === "bank" && (
              <small>
                <br />
                account no: <b>{row?.account_number || ""}</b>
                <br />
                IFSC: <b>{row?.ifsc_code || ""}</b>
              </small>
            )}

            {row?.payment_method === "upi" && (
              <small
                style={{
                  textTransform: "initial",
                }}
              >
                <br />
                {row?.upi_id || ""}
              </small>
            )}
          </span>
        );
      },
    },

    {
      dataField: "requested_img",
      text: "Print Bill",
      formatter: (_, row) => {
        const handlePrintImage = () => {
          if (row?.requested_img) {
            // Create a new window for printing
            const printWindow = window.open("", "_blank");

            // Create the HTML content for printing
            const printContent = `
              <html>
                <head>
                  <title>Print Bill</title>
                  <style>
                    body {
                      display: flex;
                      justify-content: center;
                      align-items: center;
                      margin: 0;
                      padding: 20px;
                    }
                    img {
                      max-width: 100%;
                      height: auto;
                    }
                  </style>
                </head>
                <body>
                  <img src="${row.requested_img}" alt="Bill Image" />
                </body>
              </html>
            `;

            // Write the content to the new window
            printWindow.document.write(printContent);
            printWindow.document.close();

            // Wait for the image to load before printing
            printWindow.onload = () => {
              printWindow.print();
              // Close the window after printing
              printWindow.onafterprint = () => {
                printWindow.close();
              };
            };
          }
        };

        return (
          <div
            className="actionButtonContainer"
            style={{
              flexDirection: "column",
              justifyContent: "center",
              gap: "0",
            }}
          >
            <button
              type="button"
              className="actionBtn icon"
              onClick={handlePrintImage}
              disabled={!row?.requested_img}
              style={{
                cursor: row?.requested_img ? "pointer" : "not-allowed",
                opacity: row?.requested_img ? 1 : 0.5,
              }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="currentColor"
                className="bi bi-cloud-arrow-down-fill"
                viewBox="0 0 16 16"
              >
                <path d="M8 2a5.53 5.53 0 0 0-3.594 1.342c-.766.66-1.321 1.52-1.464 2.383C1.266 6.095 0 7.555 0 9.318 0 11.366 1.708 13 3.781 13h8.906C14.502 13 16 11.57 16 9.773c0-1.636-1.242-2.969-2.834-3.194C12.923 3.999 10.69 2 8 2m2.354 6.854-2 2a.5.5 0 0 1-.708 0l-2-2a.5.5 0 1 1 .708-.708L7.5 9.293V5.5a.5.5 0 0 1 1 0v3.793l1.146-1.147a.5.5 0 0 1 .708.708" />
              </svg>
            </button>
          </div>
        );
      },
    },
    {
      dataField: "status",
      text: userInfoData?.account_type === "receptionist" ? "Action" : "",
      formatter: (_, row) => {
        const planStatus = row?.status?.replace(/ /g, "_")?.toLowerCase();
        const isSameAccount =
          (userInfoData?.uid || userInfoData?.user_id) === row?.requested_by;
        const isEditDisable = !isSameAccount || planStatus !== "pending";
        const isReceptionist = userInfoData?.account_type === "receptionist";

        return (
          <>
            {isReceptionist && isSameAccount && (
              <button
                className="actionBtn icon edit"
                disabled={isEditDisable}
                style={{
                  cursor: !isEditDisable ? "pointer" : "not-allowed",
                }}
                onClick={() =>
                  setModValues((prevs) => ({
                    ...prevs,
                    isModOpen: true,
                    cardName: "edit",
                    rowData: row,
                  }))
                }
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  className="bi bi-pencil-fill"
                  viewBox="0 0 16 16"
                  style={{
                    color: isEditDisable ? "gray" : "#CD0909",
                  }}
                >
                  <path d="M12.854.146a.5.5 0 0 0-.707 0L10.5 1.793 14.207 5.5l1.647-1.646a.5.5 0 0 0 0-.708zm.646 6.061L9.793 2.5 3.293 9H3.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.207zm-7.468 7.468A.5.5 0 0 1 6 13.5V13h-.5a.5.5 0 0 1-.5-.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.5-.5V10h-.5a.5.5 0 0 1-.175-.032l-.179.178a.5.5 0 0 0-.11.168l-2 5a.5.5 0 0 0 .65.65l5-2a.5.5 0 0 0 .168-.11z" />
                </svg>
              </button>
            )}
          </>
        );
      },
    },
  ];

  // console.log("isExpenseManager", isExpenseManager);

  return (
    <>
      {allExpenseStatsLoading ? (
        <ReactVortoxSpinner />
      ) : (
        <ExpenseStats
          allStats={allExpenseStats}
          onCardClick={onCardClick}
          selectedStatus={selectedStatus}
        />
      )}

      <div className="fullWidthFlexCenter overflowAuto separatedTable no-border-table mt30 hideMobile">
        {expenseRequestsLoading ? (
          <ReactVortoxSpinner />
        ) : (
          <PaymentLinkTable
            tableData={allDatas.allData}
            tableColumns={tbColumns}
            tablePagination={allDatas.pagination}
            isPage={isPage}
            setIsPage={(value) => setIsPage(value)}
            isFirstColSticky={true}
            pageLimit={pageLimit}
            setPageLimit={setPageLimit}
          />
        )}
      </div>

      <div className="lead-logs-card-container only-mobile">
        {expenseRequestsLoading ? (
          <ReactVortoxSpinner />
        ) : (
          <ExpenseRequestListsMobileV2
            tableData={allDatas.allData}
            setModValues={setModValues}
            tablePagination={allDatas.pagination}
            isPage={isPage}
            setIsPage={(value) => setIsPage(value)}
            isLeadLoading={expenseRequestsLoading}
            userInfoData={userInfoData}
            pageLimit={pageLimit}
            setPageLimit={setPageLimit}
            isExpenseManager={isExpenseManager}
            expenseManagerRole={expenseManagerRole}
            handleVendorImageUpload={handleVendorImageUpload}
          />
        )}
      </div>

      {/* Vendor Image Upload Modal */}
      <VendorImageUploadModal
        isOpen={vendorImageModal.isOpen}
        onClose={closeVendorImageModal}
        expenseId={vendorImageModal.expenseId}
        expenseRow={vendorImageModal.expenseRow}
        userInfoData={userInfoData}
        onSuccess={handleVendorUploadSuccess}
      />
    </>
  );
};

export default ExpenseRequestLists;
